import { mainButton } from '@tma.js/sdk-react'
import { useEffect, useEffectEvent } from 'react'

type TelegramMainButtonProps = {
  isVisible: boolean
  isLoading: boolean
  text: string
  onClick: () => void
}

export const TelegramMainButton = ({
  isVisible,
  isLoading,
  text,
  onClick,
}: TelegramMainButtonProps) => {
  const handleClick = useEffectEvent(onClick)

  useEffect(() => {
    return () => {
      mainButton.hideLoader.ifAvailable()
      mainButton.hide.ifAvailable()
    }
  }, [])

  useEffect(() => {
    if (!isVisible) {
      mainButton.hideLoader.ifAvailable()
      mainButton.hide.ifAvailable()
      return
    }

    mainButton.setText.ifAvailable(text)
    mainButton.show.ifAvailable()

    if (isLoading) {
      mainButton.disable.ifAvailable()
      mainButton.showLoader.ifAvailable()
    } else {
      mainButton.hideLoader.ifAvailable()
      mainButton.enable.ifAvailable()
    }
  }, [isLoading, isVisible, text])

  useEffect(() => {
    if (!isVisible) {
      return
    }

    const offMain = mainButton.onClick.ifAvailable(() => {
      handleClick()
    })

    return () => {
      if (offMain.ok) {
        offMain.data()
      }
    }
  }, [isVisible])

  return null
}
